export * from './lib/freshdesk.module';
export { FreshdeskService } from './lib/freshdesk.service';
export { provideFreshDesk } from './lib/providerFreshDesk';
